import { adminRoutes } from "@pages/admin"
import { legalRoutes } from "@pages/legal"
import { mrvRoutes } from "@pages/mrv"
import { technicalRoutes } from "@pages/technical"
import { transactionsRoutes } from "@pages/transactions"
import { materialRoutes, projectRoutes, transferRoutes } from "@pages/transfer"

import { Layout } from "./layout"

export const carbonBankRoutes = [
	{
		element: <Layout />,
		children: [
			...transactionsRoutes,
			...materialRoutes,
			...projectRoutes,
			...transferRoutes,
			...adminRoutes,
			...technicalRoutes,
			...mrvRoutes,
			...legalRoutes,
		],
	},
]
